import {Component, OnInit} from '@angular/core';
import {UserService} from '../../service/user.service';
import { FormGroup, FormControl } from '@angular/forms';
import {environment} from '../../../environments/environment';
import * as download from '../../../utils/downloadjs';
import { MessagingService } from '../../service/messaging.service';
import { Http, Headers, Response } from '@angular/http';
import { empty } from 'rxjs/observable/empty';


@Component({
    selector: 'app-analytics',
    templateUrl: './analytics.component.html',
    styleUrls: ['./analytics.component.scss']
})
export class AnalyticsComponent implements OnInit {

    public retrievingData = true;
    public currentUser;
    public months = [];
    public years = [];
    public newshubReportTypes = [
        'Number of items revoked by platform and region', 
        'Number of items submitted by platform and region', 
        'Number of downloads by platform and region',
        'List of api users\' downloads'
    ];
    public downloadParams = '?type=%type%&month=%month%&year=%year%&csv=true';
    public isOrgAdmin = this.userService.currentUser.level == 2
    public ldrsTypes = [
        {value: 'published_per_reporter', label: 'Number of stories published per reporter'},
        {value: 'submitted_by_reporter', label: 'Number of stories submitted for review per reporter'},
        {value: 'revoked_per_reporter', label: 'Number of stories revoked per reporter'},
        {value: 'published_by_reviewer', label: 'Number of stories published per reviewer'},
        {value: 'review_time_per_reviewer', label: 'Time spent in review per reviewer'},
        {value: 'review_time_per_story', label: 'Time spent in review per story'},
    ];
    public imsTypes = [
        {value: 'org_admins_by_location', label: 'List of organisation admins per location'},
        {value: 'org_admins_last_active', label: 'List of organisation admins\' last active date'}
    ]
    analyticsForm: FormGroup;
    private _ldrsReportURL: string = environment.wpContractUrl.replace(
        'contracts',
        this.isOrgAdmin ?
            'organisation/reports' + this.downloadParams :
            'analytics' + this.downloadParams
    );

    private _newshubReportURL: string = environment.newshubContentAPIUrl +
        'report?groupby=type-region&%pubstatus%month=%month%&year=%year%&csv=true';
    
    private _newshubDownloadsReportURL: string = environment.newshubContentAPIUrl +
        'downloadsReport?groupby=%groupby%&month=%month%&year=%year%';

    private _imsURL: string = environment.baseUrl + '/analytics/'    
    private _wpAuth: string = environment.wpAuth;

    order: string;
    direction = null;


    constructor(private userService: UserService,
                public msgService: MessagingService,
                private http: Http) {
        for (var i = 1; i <= 12; i++) {
            var date = new Date();
            var selected = date.getMonth() === (i - 1);
            date.setMonth(i - 1, 1);
            this.months.push({
                label: date.toLocaleString('en-gb', {month: 'long'}),
                value: i,
                selected: selected
            });
        }

        var currentdate = new Date();
        currentdate.getFullYear();
        for (var i = 2016; i <= currentdate.getFullYear(); i++) {
            var date = new Date();
            var selected = date.getFullYear() === (i);
            this.years.push({
                label: i,
                value: i,
                selected: selected
            });

        }
        var today = new Date();
        this.analyticsForm =  new FormGroup({
            year: new FormControl(today.getFullYear()),
            month: new FormControl(today.getMonth() + 1),
            ldrs_report_type: new FormControl(null),
            nh_report_type: new FormControl(null),
            ims_report_type: new FormControl(null)
        });
    }

    ldrsReport(e) {
        var monthDate = new Date();
        var values = this.analyticsForm.value;
        if (!values.ldrs_report_type) {
            return;
        }
        var reportName = 'LDRS - ';
        this.ldrsTypes.forEach(function(item) {
           if (item.value === values.ldrs_report_type) {
               reportName += item.label + ' - ';
           }
        });

        monthDate.setMonth(values.month - 1, 1);
        reportName += monthDate.toLocaleString('en-gb', {month: 'long'}) + ' ' + values.year;

        var requestUrl = this._ldrsReportURL
            .replace('%year%', values.year)
            .replace('%month%', values.month)
            .replace('%type%', values.ldrs_report_type);

        let params = {
            imsAuth: (this.isOrgAdmin ? localStorage.getItem('code_token') : null)
        };
        this.downloadFile(e, requestUrl, reportName, this._wpAuth, params);
    }

    newshubReport(e) {
        var monthDate = new Date();
        var values = this.analyticsForm.value;

        if (!values.nh_report_type) {
            return;
        }
        var reportName = 'Newshub - ' + values.nh_report_type + ' - ';
        var pubstatus = '';
        monthDate.setMonth(values.month - 1, 1);
        reportName += monthDate.toLocaleString('en-gb', {month: 'long'}) + ' ' + values.year;

        if (values.nh_report_type == 'Number of items revoked by platform and region') {
            pubstatus = 'pubstatus=withheld&';
        }

        switch (values.nh_report_type) {
            case 'Number of downloads by platform and region': {
                let requestUrl = this._newshubDownloadsReportURL.replace('%groupby%', 'type-region')
                    .replace('%year%', values.year).replace('%month%', values.month);
                this.downloadFile(e, requestUrl, reportName, localStorage.getItem('code_token'), {});
                break;
            }
            case 'List of api users\' downloads': {
                let requestUrl = this._newshubDownloadsReportURL.replace('%groupby%', 'user')
                    .replace('%year%', values.year).replace('%month%', values.month);
                this.downloadFile(e, requestUrl, reportName, localStorage.getItem('code_token'), {});
                break;
            }
            case 'Number of items submitted by platform and region':
            case 'Number of items revoked by platform and region': {
                let requestUrl = this._newshubReportURL.replace('%year%', values.year).replace('%month%', values.month).replace('%pubstatus%', pubstatus);
                this.downloadFile(e, requestUrl, reportName, localStorage.getItem('code_token'), {});
                break;
            }   
        }
    }

    imsReport(e) {
        var values = this.analyticsForm.value;
        if (!values.ims_report_type || (values.ims_report_type !== "org_admins_by_location" && values.ims_report_type !== "org_admins_last_active")) {
            return;
        }

        var reportName = 'IMS - ' + values.ims_report_type + ' - '+ (new Date).toLocaleString('en-gb', {day: 'numeric', month: 'long', year: 'numeric'});
        var requestURL = this._imsURL + (values.ims_report_type === "org_admins_last_active"  
            ? "orgAdminsLastActiveDate"
            : "orgAdminsByLocation");
        this.downloadFile(e, requestURL, reportName, localStorage.getItem('code_token'), {});    
    }

    downloadFile(e, url, filename, authorization, params) {
        /*if (this.isIE11) {
            this.markAsClicked(file);
            return;
        }*/

        e.preventDefault();
        /*if (file.clicked) return;
        this.markAsClicked(file);*/

        let req = new XMLHttpRequest();

        /*let progress = e.target.parentElement.getElementsByClassName('progress')[0];*/
        /*req.onprogress = function (evt) {
            if (evt.lengthComputable) {
                file.progress = Math.floor((evt.loaded / evt.total) * 100);
                progress.style.width = file.progress + '%';
            }
        };*/

        let headers = new Headers();
        headers.append('Authorization', authorization);

        if ('imsAuth' in params && params.imsAuth) {
            headers.append('ims-authorization', params.imsAuth);
        }

        this.http.get(url, { headers }).map((res: Response) => {
            download(res.text(), filename + '.csv');
            return empty();
        })
        .catch((error: Response) => {
            this.msgService.sendMessage(error);
            return empty();
        }).subscribe()

    }

    ngOnInit() {
        this.currentUser = this.userService.currentUserSubject.getValue();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/analytics/analytics.component.ts